import React from "react";
import { CardList } from "@panda0/panda0-ui";
import { Camera } from "lucide-react";

const SnapshotsSection = ({ }) => {
  return (
    <div className="pb-10 pt-6 border-t" id="snapshots">
      <div className="flex items-center mb-6">
        <div className="h-8 w-8 rounded-full bg-purple-100 text-purple-600 flex items-center justify-center mr-3">
          <Camera className="h-4 w-4" />
        </div>
        <h2 className="text-xl font-bold">Snapshots</h2>
      </div>

      <CardList.Card outerClassName="border rounded-lg shadow-sm p-4">
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-3">
          <div className="aspect-video bg-slate-300 rounded-md shadow-sm overflow-hidden">
            <img
              src="/images/snapshot-placeholder.jpg"
              alt="Candidate Snapshot"
              className="w-full h-full object-cover"
              onError={(e) => {
                e.currentTarget.src =
                  "https://placehold.co/190x120?text=Snapshot+1";
              }}
            />
          </div>
          <div className="aspect-video bg-slate-300 rounded-md shadow-sm overflow-hidden">
            <img
              src="/images/snapshot-placeholder.jpg"
              alt="Candidate Snapshot"
              className="w-full h-full object-cover"
              onError={(e) => {
                e.currentTarget.src =
                  "https://placehold.co/190x120?text=Snapshot+2";
              }}
            />
          </div>
          <div className="aspect-video bg-slate-300 rounded-md shadow-sm overflow-hidden">
            <img
              src="/images/snapshot-placeholder.jpg"
              alt="Candidate Snapshot"
              className="w-full h-full object-cover"
              onError={(e) => {
                e.currentTarget.src =
                  "https://placehold.co/190x120?text=Snapshot+3";
              }}
            />
          </div>
          <div className="aspect-video bg-slate-300 rounded-md shadow-sm overflow-hidden">
            <img
              src="/images/snapshot-placeholder.jpg"
              alt="Candidate Snapshot"
              className="w-full h-full object-cover"
              onError={(e) => {
                e.currentTarget.src =
                  "https://placehold.co/190x120?text=Snapshot+4";
              }}
            />
          </div>
        </div>
        <div className="mt-4 text-sm text-gray-500">
          <p>
            These snapshots were captured during the panda quiz to verify
            candidate identity and ensure proctoring compliance.
          </p>
        </div>
      </CardList.Card>
    </div>
  );
};

export default React.memo(SnapshotsSection);
